import { bootstrap, event, linker, setOptions } from 'vue-gtag'

import { lastUtils } from '@last/core'

async function load(googleAnalyticsId, cookies, domains) {
  if (!cookies.analysis && !domains) return
  let ids = googleAnalyticsId.split(',')
  setOptions({
    config: { id: ids[0], allow_enhanced_conversions: true },
    includes: ids.slice(1).map(id => ({ id }))
  })
  if (domains) {
    linker({ domains })
  }
  await bootstrap()
}

function isAvailable() {
  return true
}

function mapProducts(products) {
  return products.map(product => {
    return {
      id: product.id,
      item_id: product.id, // recomended by google
      name: product.name,
      item_name: product.name, // recomended by google
      quantity: product.quantity,
      price: lastUtils.round(product.finalPrice / 100)
    }
  })
}

async function checkoutCompleted({
  orderId,
  locationName,
  products,
  totalPrice,
  deliveryFee,
  taxRate,
  currencyCode,
  promotionCode
}) {
  event('purchase', {
    transaction_id: orderId,
    affiliation: locationName,
    value: lastUtils.round(totalPrice / 100),
    currency: currencyCode || 'EUR',
    tax: lastUtils.round((totalPrice - totalPrice / (1 + taxRate)) / 100),
    shipping: lastUtils.round(deliveryFee / 100),
    items: mapProducts(products),
    coupon: promotionCode
  })
}

async function addProductToCart({ product }) {
  event('add_to_cart', {
    items: mapProducts([product])
  })
}

async function removeProductFromCart({ product }) {
  event('remove_from_cart', {
    items: mapProducts([product])
  })
}

async function beginCheckout({
  products,
  totalPrice,
  currencyCode,
  promotionCode
}) {
  event('begin_checkout', {
    currency: currencyCode || 'EUR',
    value: lastUtils.round(totalPrice / 100),
    items: mapProducts(products),
    coupon: promotionCode
  })
}

async function userLoggedIn() {
  event('login')
}

async function userSignedUp() {
  event('sign_up')
}

async function itemViewed({ item, currencyCode }) {
  let products = mapProducts([item])
  event('view_item', {
    currency: currencyCode || 'EUR',
    value: products[0].price,
    items: products
  })
}

async function bookingOnGoing() {
  event('booking_on_going')
}

async function bookingDone() {
  event('booking_done')
}

async function autoOnboardingDone() {
  event('conversion', {
    send_to: 'AW-707525438/Gq10CKWPsY0YEL72r9EC'
  })
}

function newLead() {
  event('conversion', {
    send_to: 'AW-707525438/Gq10CKWPsY0YEL72r9EC'
  })
}

export default {
  checkoutCompleted,
  isAvailable,
  addProductToCart,
  removeProductFromCart,
  beginCheckout,
  userLoggedIn,
  userSignedUp,
  itemViewed,
  bookingOnGoing,
  bookingDone,
  autoOnboardingDone,
  newLead,
  load
}
